import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  Loading,
  Pagination,
  TableCell,
  TableToolbar,
  DataTableSkeleton,
  TableSelectRow,
  DataTable,
  TableToolbarContent,
  TableBatchActions,
  TableBatchAction,
} from 'carbon-components-react';
import { Link } from 'react-router-dom';
import View16 from '@carbon/icons-react/lib/view--filled/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import '../../scss/custom.scss';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getError,
  STATUS,
  entitiesLabels,
  apioperation,
  getSuccess,
} from '../../helpers/Constants';
import { api, registry, dynamic } from '../../helpers/api/api';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import CARModal from './CARModal';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import { CanExecuteAction, IsInRole, IsEditable } from '../../helpers/authorization/Policies';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import { CheckmarkOutline16, CheckmarkFilled20, Add20, Error16 } from '@carbon/icons-react/lib/';
import { AppContext } from '../../helpers/context/AppContext';
import { WFActionModal } from '../common/WFActionModal';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { Online, Offline } from '../common/OnLineOffLine';
import IncidentRepository from '../../helpers/api/IncidentRepository';

export default class CARList extends Component {
  initialState = (props) => {
    let idIncidentEdit = props ? props.match.params.id : '';

    let initialState = {
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      idIncidentEdit: idIncidentEdit,
      isLoading: true,
      incidentEditModel: null,
      isSubmitted: false,

      //modal insert/edit
      keyModalCAR: `modalCAR_${new Date().getTime()}`,
      editModelCAR: null,
      isEditModalCAR: false,
      isOpenModalCAR: false,
      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: false,

      incidentModel: {
        id: null,
        incidentCAR: [],
      },
      appStatus: null,
      appDirectCause: null,
      appDirectCauseSubCategory: null,
      appRootCause: null,
      appRootCauseSubCategory: null,
      appRootCauseSubCategoryDetail: null,

      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
    };
    return initialState;
  };

  constructor(props) {
    super(props);

    this.updateState = this.updateState.bind(this);
    // this.handleChangeCombo = this.handleChangeCombo.bind(this);
    this.state = {
      ...this.initialState(props),
    };
    this.baseUrl = '/incident/' + this.state.idIncidentEdit + '/car/';
  }

  baseUrl;

  componentDidMount() {
    this.getStatus();
    this.getCARs();
    this.getCauses();
  }

  getCauses() {
    //appDirectCause
    dynamic
      .getAll('directcause', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appDirectCause: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DIRECTCAUSE, apioperation.GET)
        );
      })
      .finally(() => {});

    //appDirectCauseSubCategory
    dynamic
      .getAll('directcausedetail', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appDirectCauseSubCategory: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DIRECTCAUSEDETAIL, apioperation.GET)
        );
      })
      .finally(() => {});

    //appRootCause
    dynamic
      .getAll('rootcause', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appRootCause: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROOTCAUSE, apioperation.GET)
        );
      })
      .finally(() => {});

    //appRootCauseSubCategory
    dynamic
      .getAll('rootcausedetail', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appRootCauseSubCategory: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROOTCAUSEDETAIL, apioperation.GET)
        );
      })
      .finally(() => {});

    //appRootCauseSubCategoryDetail
    dynamic
      .getAll('rootcausesubdetail', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appRootCauseSubCategoryDetail: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROOTCAUSESUBDETAIL, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  showLoading() {
    let show = (this.state.isEdit && this.state.isLoading) || this.state.isSubmitted;
    let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active={true} withOverlay={true} description={descr} />;
    //return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  getCARs() {
    this.setState({
      isLoading: true,
    });
    let data = {
      params: {
        page: this.state.currentPage,
        pageSize: this.state.pageSize,
      },
    };
    api
      .getWithParam(this.baseUrl, data)
      .then((response) => {
        let data = response.data;
        if (data) {
          this.setState({
            incidentModel: {
              id: data.id,
              incidentCAR: data.incidentCAR.itemList,
              incident: data.incident,
              incidentCode: data.incidentCode,
            },
            page: data.incidentCAR.currentPage,
            pageSize: data.incidentCAR.pageSize,
            pageCount: data.incidentCAR.pageCount,
            rowCount: data.incidentCAR.rowCount,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`, 'CARs not found');
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CAR, apioperation.GET)
        );
      })
      .finally(() => {
        // this.setState({
        //   isLoading: false,
        // });
        //RITM0623666
        this.getIncidentReportCompiler()
      });
  }

  getStatus = () => {
    registry
      .getAll('status')
      .then((response) => {
        var data = response.data;
        //data = data != null ? data.filter(item => (item.id == 1 || item.id == 4)) : [];
        this.setState({
          appStatus: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.STATUS, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  /**********CAR********************/

  toggleModalCAR = (open) => {
    this.setState({ isOpenModalCAR: open });
  };

  addCar = () => {
    this.setState({ keyModalCAR: `modalCAR_${new Date().getTime()}` });
    this.setState({ isEditModalCAR: false, isOpenModalCAR: true, editModelCAR: null });
  };

  editModalCAR = (id) => {
    this.setState({ keyModalCAR: `modalCAR_${new Date().getTime()}` });
    let item = this.state.incidentModel.incidentCAR.find((el) => el.id == id);
    this.setState({ editModelCAR: item, isEditModalCAR: true, isOpenModalCAR: true });
  };

  updateCacheList = async (datiForm) => {
    let directCauseSubCategory = (this.state.appDirectCauseSubCategory || []).find(
      (el) => el.id == datiForm.idDirectCauseSubCategory
    );
    let rootCauseSubCategory = (this.state.appRootCauseSubCategory || []).find(
      (el) => el.id == datiForm.idRootCauseSubCategory
    );
    let rootCauseSubCategoryDetail = (this.state.appRootCauseSubCategoryDetail || []).find(
      (el) => el.id == datiForm.idRootCauseSubCategoryDetail
    );

    if (!this.state.isEditModalCAR) {
      //add new CAR
      datiForm['idStatus'] = 1;
      datiForm['status'] = {
        id: 1,
        name: 'Draft',
        planningName: 'Draft',
        reportingName: 'Opened',
        carManagementName: 'Assigned',
        caManagementName: 'Draft',
      };
      datiForm['ca'] = [];
      //incidentCARCode
      //progressiveId
      //sequence

      //creazione della cache per la pagina di dettaglio della car
      let carDetail = Object.assign({}, datiForm);
      carDetail['incidentCode'] = this.state.incidentModel?.incident?.incidentCode;
      carDetail['incident'] = this.state.incidentModel?.incident;
      carDetail['directCause'] = (this.state.appDirectCause || []).find(
        (el) => el.id == directCauseSubCategory?.idDirectCause
      );
      carDetail['rootCause'] = (this.state.appRootCause || []).find(
        (el) => el.id == rootCauseSubCategory?.idRootCause
      );
      carDetail['directCauseSubCategory'] = directCauseSubCategory?.name || null;
      carDetail['rootCauseSubCategory'] = rootCauseSubCategory?.name || null;
      carDetail['rootCauseSubCategoryDetail'] = rootCauseSubCategoryDetail?.name || null;

      await IncidentRepository.createCachedIncidentCARDatail(
        this.state.idIncidentEdit,
        datiForm.id,
        carDetail
      );
    }

    datiForm['directCauseSubCategory'] = directCauseSubCategory || null;
    datiForm['rootCauseSubCategory'] = rootCauseSubCategory || null;
    datiForm['rootCauseSubCategoryDetail'] = rootCauseSubCategoryDetail || null;

    console.log({ datiForm });
    await IncidentRepository.updateCachedIncidentCAR(this.state.idIncidentEdit, datiForm);
  };

  handleSaveModalCAR = (datiForm) => {
    //showNotification.warning("TODO Validazione su CARModal.js");

    if (!datiForm) return;

    this.setState({
      isSubmitted: true,
    });

    if (!this.state.isEditModalCAR) datiForm.idIncident = this.state.idIncidentEdit;

    let method = this.state.isEditModalCAR
      ? api.put(this.baseUrl, datiForm, datiForm.id)
      : api.post(this.baseUrl, datiForm);

    method
      .then((response) => {
        if (response.status == 200) {
          this.updateCacheList(datiForm).then(() => {
            this.getCARs();
          });

          this.setState({
            isOpenModalCAR: false,
          });
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            `${entitiesLabels.INCIDENT} ${entitiesLabels.CAR} 
          ${getSuccess(
            response.data.incidentCARCode,
            this.state.isEditModalCAR ? apioperation.PUT : apioperation.POST
          )}`
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(
            error,
            entitiesLabels.CAR,
            this.state.isEditModalCAR ? apioperation.PUT : apioperation.POST
          )
        );
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      });
  };

  confirmDeleteCAR = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItemCAR = () => {
    let id = this.state.idToDelete;

    this.setState({
      isDeleting: true,
    });

    api
      .delete(this.baseUrl, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseConfirm();
          this.getCARs();
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            `${entitiesLabels.INCIDENT} ${entitiesLabels.CAR} 
          ${getSuccess(
            response.data.incidentCARCode,
            this.state.isEditModalCAR ? apioperation.PUT : apioperation.DELETE
          )}`
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CAR, apioperation.DELETE)
        );
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };
  /**********Fine CAR********************/

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    let action = this.state.approvalModalAction.toLowerCase();
    let apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put('/incident/' + this.state.incidentModel.id + '/car/' + apiEndpoint, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            `${entitiesLabels.INCIDENT} ${entitiesLabels.CAR} 
          ${getSuccess(response?.data?.incidentCARCode, apioperation.DELETE)}`
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
            incidentModel: {
              incidentCAR: [],
            },
          });
          this.getCARs();
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CAR, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  IsRowSelectable(row, selectedRows) {
    var row = this.state.incidentModel.incidentCAR.find((i) => i.id == row.id);

    //if (row.status.id == STATUS.Consolidated) return false;//la CAR può essere riaperta

    if (selectedRows.length == 0) {
      return true;
    }

    if (selectedRows.length > 0) {
      var selectableIncident = this.state.incidentModel.incidentCAR.find(
        (i) => i.id == selectedRows[0].id
      );
      var selectableState = selectableIncident.status.id;

      //solo per la chiusura delle CAR
      if (selectableState == STATUS.Approved) {
        return this.canCloseCAR(selectedRows[0].id)
          ? row.status.id == STATUS.Approved && this.canCloseCAR(row.id)
          : false;
      }
      //per il submit delle CAR
      if (selectableState == STATUS.Draft) {
        return this.canApproveCAR(selectedRows[0].id)
          ? row.status.id == STATUS.Draft && this.canApproveCAR(row.id)
          : false;
      }

      if (row.status.id == selectableState) {
        return true;
      }

      return false;
    }

    return false;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover: withApprover,
      selectedData: selectedRows,
      approverRole: approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired: approvalNotesRequired,
    });
  }
  handleChangePaging = async (page) => {
    await new Promise((resolve) => {
      this.setState(
        { currentPage: page.page, pageSize: page.pageSize, loading: true, isBack: false },
        resolve
      );
    });
    this.getCARs();
  };
  getCanEditResourceId = (selectedRows) => {
    const canEditResource = this.state.incidentModel &&
      this.state.incidentModel.incident && {
        idCompiler: this.state.incidentModel.incident.idCompiler,
        idDataApprover: this.state.incidentModel.incident.idDataApprover,
        idDivisionManager: this.state.incidentModel.incident.idDivisionManager,
        email: '',
      };
    if (selectedRows && selectedRows.length > 0) {
      let car = this.state.incidentModel.incidentCAR.find((el) => el.id == selectedRows[0].id);
      canEditResource.email =
        car.owner != null
          ? car.owner.email
          : car.ownerSaipem != null
          ? car.ownerSaipem.email
          : null;
    }
    //console.log(canEditResource);
    return canEditResource;
  };

  getStatusId = (idRow) => {
    let r = this.state.incidentModel.incidentCAR.find((el) => el.id == idRow);
    return r && r.idStatus;
  };

  canApproveCAR = (idRow) => {
    let item = this.state.incidentModel.incidentCAR.find((el) => el.id == idRow);
    return item && item.ca && item.ca.length > 0;
  };

  canCloseCAR = (idRow) => {
    let item = this.state.incidentModel.incidentCAR.find((el) => el.id == idRow);
    return item && item.ca && item.ca.length > 0
      ? item.ca.filter((el) => el.idStatus == 4).length == item.ca.length
      : false;
  };

  //RITM0623666
  getIncidentReportCompiler = async () => {
    this.setState({ loading: true });
    let incidentCompiler = null;
    const incidentId = this.state.incidentModel.incident.id
    const idCompiler = this.state.incidentModel.incident.idCompiler
    try {
      if(!incidentId) return null
      incidentCompiler = (await api.getAll(`/users/${idCompiler}`)).data;
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.USER, apioperation.GET));
    }
    this.setState({incidentModel: {...this.state.incidentModel, incidentCompiler,}, isLoading: false})
  };
//FIne RITM0623666
  render() {
    const headersDataTable = [
      { key: 'owner', header: 'Owner' },
      { key: 'carCode', header: 'CAR Code' },
      { key: 'duedate', header: 'Due Date', type: 'date' },
      { key: 'status', header: 'Status', type: 'status' },
      { key: 'carOwnerInvolved', header: 'CAR Owner Involved', type: 'bool' },
      { key: 'closedCa', header: 'Closed CA' },
    ];

    const skeletonRowCount = 10;

    const rows = [];

    if (this.state.incidentModel.incidentCAR) {
      //Create Ad Hoc DTO
      const cars = this.state.incidentModel.incidentCAR.sort(function (a, b) {
        var sequenceA = new Date(a.sequence),
          sequenceB = new Date(b.sequence);
        return sequenceA - sequenceB;
      });
      const statusIncident = this.state.incidentModel?.incident?.idStatus;
      cars.forEach(function (item) {
        rows.push({
          id: item.id,
          status: item.status.carManagementName,
          owner:
            item.owner != null
              ? item.owner.name + ' ' + item.owner.surname
              : item.ownerSaipem.name + ' ' + item.ownerSaipem.surname,
          carCode: item.incidentCARCode,
          duedate: item.dueDate,
          carOwnerInvolved: statusIncident > 2,
          closedCa:
            item.ca && item.ca.length > 0
              ? item.ca.filter((el) => el.idStatus == 4).length + '/' + item.ca.length
              : '',
        });
      });
    }

    const CARModalProps = {
      key: this.state.keyModalCAR,
      title: 'CAR',
      editModel: this.state.editModelCAR,
      isOpenModal: this.state.isOpenModalCAR,
      isEditModal: this.state.isEditModalCAR,
      idIncident: this.state.incidentModel.id,
      toggleModal: this.toggleModalCAR,
      save: this.handleSaveModalCAR,
      appStatus: this.state.appStatus,
      appDirectCause: this.state.appDirectCause,
      appRootCause: this.state.appRootCause,
      appDirectCauseSubCategory: this.state.appDirectCauseSubCategory,
      appRootCauseSubCategory: this.state.appRootCauseSubCategory,
      appRootCauseSubCategoryDetail: this.state.appRootCauseSubCategoryDetail,
      //RITM0623666
      incidentCompiler: this.state.incidentModel.incidentCompiler
    };

    const getNameCARById = (id) => {
      if (id == null) return '';
      let element = rows.find((el) => el.id == id);
      return element && element.owner && element.status
        ? `${element.owner} - ${element.duedate} - ${element.status}`
        : '';
    };

    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      nameItem: getNameCARById(this.state.idToDelete),
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, //open state
      onCloseConfirm: this.onCloseConfirm, //no click
      deleteItem: this.deleteItemCAR, //yes click fn()
    });

    //const incident = this.state.incidentModel && this.state.incidentModel.incident ? this.state.incidentModel.incident : null;
    // const canEditResource = (this.state.incidentModel && this.state.incidentModel.incident) && {
    //     idCompiler: this.state.incidentModel.incident.idCompiler,
    //     idDataApprover: this.state.incidentModel.incident.idDataApprover,
    //     idDivisionManager: this.state.incidentModel.incident.idDivisionManager,
    // };
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb //Todo fare if in base al ruolo?
              linkTo={'/incident/' + this.state.idIncidentEdit}
              linkText="Incident"
              titleLeft={
                'Incident Id: ' +
                ((this.state.incidentModel && this.state.incidentModel.incidentCode) || '') +
                '  -  CAR List'
              }
              // titleCenter={this.state.incidentModel && 'ID: ' + this.state.incidentModel.incidentCAR.progressiveId}
              //titleRight={this.state.incidentModel && this.state.incidentModel.incidentCAR.status  ? this.state.incidentModel.incidentCAR.status.reportingName : null}
            />
            <div className="mainContainer">
              <ConfirmAlertCustom {...confirmDelProps()} />
              {this.showLoading()}

              <WFActionModal
                show={this.state.isApprovalModalOpen}
                title={`${this.state.approvalModalAction} Incident CARs`}
                action={this.state.approvalModalAction}
                withApprover={this.state.withApprover}
                approver={this.state.approver}
                approverRole={this.state.approverRole}
                approverOptions={this.state.approvers}
                isLoadingOperation={this.state.isLoadingWFOperation}
                onApproverSelect={this.handleApproverSelect}
                isLoadingOptions={this.state.isLoadingApproverOptions}
                onCancel={this.handleCloseApprovalModal}
                onConfirm={this.handleConfirmApprovalModal}
                onApprovalNotesChange={this.handleApprovalNotesChange}
                approvalNotes={this.state.approvalNotes}
                approvalNotesRequired={this.state.approvalNotesRequired}
                validationMessages={this.state.approvalValidationMessages}
              />

              <TableToolbar>
                <h3 className="title--medium max-width"></h3>
                {CanExecuteAction(
                  'Incident',
                  'CARManagement',
                  user,
                  '',
                  'Create',
                  this.getCanEditResourceId(null)
                ) && this.state.incidentModel?.incident?.status?.id < 3 ? (
                  <Button onClick={() => this.addCar()} renderIcon={Add16}>
                    Add new CAR
                  </Button>
                ) : null}
              </TableToolbar>

              <DataTable
                rows={rows || []}
                headers={headersDataTable}
                useZebraStyles={true}
                size="compact"
                render={({
                  rows,
                  headers,
                  getHeaderProps,
                  getRowProps,
                  getTableProps,
                  getSelectionProps,
                  selectedRows,
                  getBatchActionProps,
                }) => (
                  <TableContainer className="bx--grid--full-width" title="">
                    {selectedRows.length > 0 ? (
                      <Online>
                        <TableToolbar>
                          <TableToolbarContent>
                            <TableBatchActions {...getBatchActionProps()}>
                              {/* {this.canApproveCAR(selectedRows[0].id) &&
                              CanExecuteAction(
                                'Incident',
                                'CARManagement',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Submit',
                                this.getCanEditResourceId(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Send16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Submit',
                                      'Submit',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Submit CAR
                                </TableBatchAction>
                              ) : null} */}

                              {this.canApproveCAR(selectedRows[0].id) &&
                              CanExecuteAction(
                                'Incident',
                                'CARManagement',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Approve',
                                this.getCanEditResourceId(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Approve',
                                      'Approve',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Approve CAR
                                </TableBatchAction>
                              ) : null}

                              {this.canCloseCAR(selectedRows[0].id) &&
                              CanExecuteAction(
                                'Incident',
                                'CARManagement',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Consolidate',
                                this.getCanEditResourceId(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Close',
                                      'Close',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Close CAR
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Incident',
                                'CARManagement',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Open',
                                this.getCanEditResourceId(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={CheckmarkOutline16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Open',
                                      'Open',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Open CAR
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Incident',
                                'CARManagement',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Reject',
                                this.getCanEditResourceId(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Error16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'Reject',
                                      'Reject',
                                      null,
                                      false,
                                      true,
                                      selectedRows
                                    )
                                  }
                                >
                                  Reject CAR
                                </TableBatchAction>
                              ) : null}

                              {CanExecuteAction(
                                'Incident',
                                'CARManagement',
                                user,
                                selectedRows.length > 0
                                  ? this.getStatusId(selectedRows[0].id)
                                  : null,
                                'Delete',
                                this.getCanEditResourceId(selectedRows)
                              ) ? (
                                <TableBatchAction
                                  renderIcon={Delete16}
                                  onClick={() =>
                                    this.batchActionClick(
                                      'DELETE',
                                      'Delete',
                                      null,
                                      false,
                                      false,
                                      selectedRows
                                    )
                                  }
                                >
                                  Delete CAR
                                </TableBatchAction>
                              ) : null}
                            </TableBatchActions>
                          </TableToolbarContent>
                        </TableToolbar>
                      </Online>
                    ) : (
                      ''
                    )}

                    {this.state.isLoading ? (
                      <DataTableSkeleton
                        headers={[]}
                        rowCount={skeletonRowCount}
                        zebra={false}
                        compact={false}
                      />
                    ) : (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableHeader className="align-center"></TableHeader>

                            {headers.map((header) => (
                              <TableHeader
                                className={header.type == 'bool' ? 'align-center' : ''}
                                {...getHeaderProps({ header })}
                              >
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder colSpan={headers.length + 2} />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {this.IsRowSelectable(row, selectedRows) ? (
                                  <>
                                    {' '}
                                    <Online>
                                      <TableSelectRow {...getSelectionProps({ row })} />
                                    </Online>{' '}
                                    <Offline>
                                      <TableSelectRow disabled={true} />
                                    </Offline>
                                  </>
                                ) : (
                                  <TableCell
                                    key={'empty' + row.id}
                                    className="tableActions align-center"
                                  ></TableCell>
                                )}
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                <TableCell
                                  key={'action-' + row.id}
                                  className="tableActions align-center"
                                >
                                  <div>
                                    {IsEditable(
                                      'Incident',
                                      'CARManagement',
                                      user,
                                      this.getStatusId(row.id),
                                      'All',
                                      this.getCanEditResourceId(null)
                                    ) ? (
                                      <Button
                                        onClick={() => this.editModalCAR(row.id)}
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        kind="ghost"
                                      />
                                    ) : null}
                                    <Link to={this.baseUrl + row.id}>
                                      <Button
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Detail"
                                        kind="ghost"
                                      />
                                    </Link>

                                    {/*<Button onClick={() => this.confirmDeleteCAR(row.id)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" />*/}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                )}
              />
              <div className="footer-pagination">
                <Pagination {...paginationProps()} />
              </div>
              <CARModal {...CARModalProps} />
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
